export default __webpack_public_path__ + "static/media/gdp-white.bacb9f9f.svg";